import { cn } from "@/lib/utils";
import { Table } from "@tanstack/react-table";
import { Flipped, Flipper } from "react-flip-toolkit";
import { RiGalleryLine, RiListCheck } from "react-icons/ri";
import { useTooltipProps } from "../tooltip";
import { useTranslation } from "react-i18next";

export function TableGalleryToggle<TData>({ table }: { table: Table<TData> }) {
  const gallery = table.getState().gallery;
  const tooltipProps = useTooltipProps();
  const { t } = useTranslation();
  return (
    <Flipper flipKey={gallery} className="relative">
      <button
        data-component="data-table-gallery-toggle"
        className="bg-muted rounded-md flex p-1 gap-2"
        onClick={(_ev) => table.setGallery((g) => !g)}
      >
        <Flipped flipId="bg">
          <div
            className={cn(
              "w-1/2 h-full bg-azure/10 absolute z-[0] top-0",
              gallery ? "right-0 rounded-r-md" : "left-0 rounded-l-md",
            )}
          ></div>
        </Flipped>
        <RiListCheck
          data-component="data-table-gallery-toggle-list"
          {...tooltipProps}
          data-tooltip-content={t("listView")}
          className={cn("z-[1]", !gallery && "text-azure")}
          // onClick={(ev) => table.setGallery(false)}
        />
        <RiGalleryLine
          data-component="data-table-gallery-toggle-gallery"
          {...tooltipProps}
          data-tooltip-content={t("galleryView")}
          className={cn("z-[1]", gallery && "text-azure")}
          // onClick={(ev) => table.setGallery(true)}
        />
      </button>
    </Flipper>
  );
}
